import React, {FC} from 'react';

import {AttachmentModel} from '../../../../../models/api/attachmentModel';
import {downloadAttachmentAsync, previewAttachmentAsync} from '../../../../../services/browser';
import {MessageViewerImageControls} from './messageViewerImageControls';

/*
 * Props.
 */

interface MessageViewerImageControlsContainerProps {
  attachments: ReadonlyArray<AttachmentModel>;
}

/*
 * Component.
 */

export const MessageViewerImageControlsContainer: FC<MessageViewerImageControlsContainerProps> = (props) => (
  <MessageViewerImageControls
    attachments={props.attachments}
    onPreviewAttachmentClickAsync={previewAttachmentAsync}
    onDownloadAttachmentClickAsync={downloadAttachmentAsync}
  >
    {props.children}
  </MessageViewerImageControls>
);
